<!--
 * @Author: Jason
 * @Date: 2019-10-15 17:32:50
 * @version: 
 * @LastEditors: Jason
 * @LastEditTime: 2019-10-29 14:33:43
 * @Descripttion: 
 -->
<template>
    <div class="msg">
        <div class="msg-title">{{title}}</div>
        <div class="msg-content">
            <slot></slot>
        </div>
        <div class="flex-btwn-aic msg-footer">
            <div class="msg-no-btn" v-show="isShowOff" :style="{width:isShowOk?'50%':'100%'}" @click="closeFun()">{{noText}}</div>
            <div class="msg-ok-btn" v-show="isShowOk" :style="{width:isShowOff?'50%':'100%'}" @click="confirmFun()">{{okText}}</div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        title: {
            type: String,
            default: '温馨提示'
        },
        okText:{
            type: String,
            default: '确定'
        },
        noText:{
            type: String,
            default: '取消'
        },
        isShowOk:{
            type:Boolean,
            default:true
        },
        isShowOff:{
            type:Boolean,
            default:true
        }
    },
    data() {
        return {
            
        };
    },
    methods:{
        closeFun(){
            this.$emit('close')
        },
        confirmFun(){
            this.$emit('confirm')
        }
    }
}
</script>
<style lang="scss" scoped>
// 确认提示框样式
.mask{
  .msg{
    width: 80%;
    background-color: #fff;
    @mixin msg-box {
      width: 100%;
      height: 12.8vw;
      font-size: 4.2667vw;
      line-height: 12.8vw;
      text-align: center;
    }
    .msg-title{
      @include msg-box;
      font-weight: bold;
    }
    .msg-content{
      padding: 2vw 4vw 5.3333vw ;
      text-align: center;
    }
    .msg-footer{
      @include msg-box;
      border-top: 1px solid #F1F1F3;
      .msg-no-btn,.msg-ok-btn{
        width: 50%;
      }
      .msg-ok-btn{
        color: #16A085;
        border-left: 1px solid #F1F1F3;
      }
    }
  }
}
</style>


